// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"79205f4e","453":"8083f30a","622":"879b2fbd","628":"b25b4a4d","664":"ed3318d0","851":"9d810a0e"}[chunkId] + ".chunk.js";
};